
export class VehiclePossibleStolenReport {

    public id: number;

    public businessTransactionNumberId: number; // this should be present in the database too

    public customerNameId: number;

    public customerNumberId: number;

    public agentCustomerNameId: number;

    public agentCustomerNumberId: number;

    public vehiclePartStolenTypeId: number;

    public leaStatusTypeId: number;

    // public vehicleStolenAgencyStatusTypeId: number;

    public businessTransactionTypeId: number;

    public reportPreparedUserLoginId: number;

    public additionalRemarksUserLoginId: number;

    public nmvtisStolenVehicleReportStatusTypeId: number;

    public nmvtisFindingTypeId: number;

    public nmvtisActionTakenTypeId: number;

    public ownerCustomerIdentificationTypeId: number;

    public agentCustomerIdentificationTypeId: number;

    public nmvtisvin: string;

    public nmvtisModelYear: number;

    public nmvtisMake: string;

    public nmvtisModel: string;

    public nmvtisCaseNumber: string;

    public nmvtisReportingAgency: string;

    public nmvtisReportingJurisdiction: string;

    public nmvtisPartDescription: string;

    public nmvtisReportingAgentName: string;

    public nmvtisReportingAgentBadgeNumber: string;

    public nmvtisReportingAgencyStatusTypeId: number;

    public nmvtisReportingAgencyRemarks: string;

    public leAgentName: string;

    public leaBadgeNumber: string;

    public leaRemarks: string;

    public additionalRemarks: string;

    public previousRemarks: string;

    public reasonToProceed: string;

    public isNMVTISReportingAgencyCalled: boolean;

    public isPartsStolen: boolean;

    public isReferredMVD: boolean;

    public isLEACalled: boolean;

    public nmvtisTheftStatusDate: Date;

    public reportPreparedDate: Date;

    public addtionalRemarksDate: Date;

}
